import config from 'config';
import { getLocalAssetUrl } from 'core/utilities';
import { ButtonSolid } from 'ui/components/primitives';
import EmptyCart from './EmptyCart.styles';
import { EMPTY_CART_CONST } from './EmptyCart.d';
import type { EmptyCartProps } from './EmptyCart.d';

const EmptyCartBase = ({ onClick }: EmptyCartProps) => (
  <EmptyCart.Container data-testid={EMPTY_CART_CONST.TEST_ID}>
    <EmptyCart.Figure
      alt="Seu carrinho está vazio!"
      ratio="1x1"
      src={getLocalAssetUrl(`/images/icon-cart-${config.app.short}.svg`)}
    />
    <EmptyCart.Heading as={6} level={6}>
      Seu carrinho está vazio!
    </EmptyCart.Heading>
    <EmptyCart.Text variant="body-large-short">
      Navegue pelo site, escolha seus produtos e adicione no carrinho.
    </EmptyCart.Text>
    <ButtonSolid onClick={onClick} stretch variant="conversion">
      Ver produtos
    </ButtonSolid>
  </EmptyCart.Container>
);

export default EmptyCartBase;
